<template>
  <select
    v-model="computedLanguage"
    dir="rtl"
    :class="['languageSwitch', { 'languageSwitch--dark': dark }]"
  >
    <option value="en">EN</option>
    <option value="de">DE</option>
  </select>
</template>

<script>
export default {
  name: 'CSLanguageSwitch',

  data: () => ({
    chosenLanguage: 'en',
  }),

  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedLanguage: {
      get() {
        return this.$store.getters.chosenLanguage
      },
      set(value) {
        this.$store.dispatch('switchLanguage', value)
      },
    },
  },
}
</script>
